export const getUserInitials = (firstName: string | undefined | null, lastName?: string | undefined | null) => {
  return `${firstName ? firstName[0] : ''}${lastName ? lastName[0] : ''}`;
};

export const getUserInitialsFromFullName = (name: string) => {
  const [firstName = "", lastName = ""] = name?.split(" ") || [];
  return getUserInitials(firstName, lastName);
};
